import { ReactElementFactory } from "survey-react-ui";
import { LayoutPanel, Question, Row } from "../elements";
import { createElement } from "react";
import { Panel } from "../elements/Panel";
import { ElementFactory } from "survey-core";
import {
  AppointmentTimeSlotQuestionModel,
  CheckboxGroupLargeQuestionModel,
  DamageFromDirectionQuestionModel,
  DatePickerQuestionModel,
  FeatureListQuestionModel,
  LicensePlateQuestionModel,
  PhoneNumberQuestionModel,
  RepairAllowedModel,
  SelectorQuestionModel,
  SignatureQuestionModel,
  TimePickerQuestionModel,
} from "../questions";
import { ViewQuestionModel } from "../questions/ViewQuestion";

export const registerElements = () => {
  /* Custom Questions */
  ElementFactory.Instance.registerElement("appointment-time-slot", (name) => {
    return new AppointmentTimeSlotQuestionModel(name);
  });

  ElementFactory.Instance.registerElement("checkboxGroupLarge", (name) => {
    return new CheckboxGroupLargeQuestionModel(name);
  });

  ElementFactory.Instance.registerElement("damage-from-direction", (name) => {
    return new DamageFromDirectionQuestionModel(name);
  });

  ElementFactory.Instance.registerElement("datepicker", (name) => {
    return new DatePickerQuestionModel(name);
  });

  ElementFactory.Instance.registerElement("licensePlate", (name) => {
    return new LicensePlateQuestionModel(name);
  });

  ElementFactory.Instance.registerElement("repairAllowed", (name) => {
    return new RepairAllowedModel(name);
  });

  ElementFactory.Instance.registerElement("featurelist", (name) => {
    return new FeatureListQuestionModel(name);
  });

  ElementFactory.Instance.registerElement("selector", (name) => {
    return new SelectorQuestionModel(name);
  });

  ElementFactory.Instance.registerElement("signature", (name) => {
    return new SignatureQuestionModel(name);
  });

  ElementFactory.Instance.registerElement("timepicker", (name) => {
    return new TimePickerQuestionModel(name);
  });

  ElementFactory.Instance.registerElement("phoneNumber", (name) => {
    return new PhoneNumberQuestionModel(name);
  });

  ElementFactory.Instance.registerElement("view", (name) => {
    return new ViewQuestionModel(name);
  });

  /* Custom Elements to override SurveyJS defaults */
  ReactElementFactory.Instance.registerElement("sv-page", (props) => {
    return createElement(LayoutPanel, props);
  });

  ReactElementFactory.Instance.registerElement("panel", (props) => {
    return createElement(Panel, props);
  });

  ReactElementFactory.Instance.registerElement("sv-row-wrapper-rd", (props) => {
    return createElement(Row, props);
  });

  ReactElementFactory.Instance.registerElement("question", (props) => {
    return createElement(Question, props);
  });
};
